import { put, takeEvery, all } from 'redux-saga/effects';

import applicationApi from '../api/applicationApi';
import {
  APPLICATION_REQUEST,
  applicationSuccess,
  applicationFailure,
  APPLICATION_COUNT_BY_STATUS_REQUEST,
  applicationCountByStatusSuccess,
  applicationCountByStatusFailure
} from '../actions/applicationActions';
import { careersSingleSuccess } from '../actions/careersActions';
import { apiWithAuth } from './requestSagas';
import { pageUpdate } from '../actions/settingsActions';

function* applicationRequest(action) {
  try {
    const result = yield apiWithAuth(applicationApi.getApplications, action);
    yield put(applicationSuccess(result.data.data, action.payload));
    if (result.data.career) {
      yield put(careersSingleSuccess(result.data.career));
      yield put(pageUpdate(`Application: ${result.data.career.title}`));
    } else {
      yield put(pageUpdate(`Application`));
    }
  } catch (error) {
    yield put(applicationFailure(error));
  }
  // return;
  // try {
  //   const accessToken = yield select(getAccessToken);
  //   // yield put({type: LOGIN_REQUEST});
  //   // yield delay(1000);
  //   const result = yield call(applicationApi.getApplications, action.payload, {
  //     'Authorization': `Bearer ${accessToken}`
  //   });
  //   yield put({type: APPLICATION_SUCCESS, payload: result.data, params: action.payload});
  //   if (result.career) {
  //     yield put({type: CAREERS_SINGLE_SUCCESS, payload: result.career});
  //   }
  // } catch (error) {
  //   yield put({type: APPLICATION_FAILURE, payload: error});
  // }
}

function* applicationCountByStatusRequest(action) {
  try {
    const result = yield apiWithAuth(applicationApi.getApplicationsCountByStatus, action);
    yield put(applicationCountByStatusSuccess(result.data, action.payload));
  } catch (error) {
    yield put(applicationCountByStatusFailure(error));
  }
}

export default function* rootSaga() {
  yield all([takeEvery(APPLICATION_REQUEST, applicationRequest)]);
  yield all([takeEvery(APPLICATION_COUNT_BY_STATUS_REQUEST, applicationCountByStatusRequest)]);
}
